import apiFetch from 'utils/apiFetch';

export const acceptCodeOfHonor = (params) => {
  return apiFetch('POST', { endPoint: 'elements/connection' }, params);
};



// WEBPACK FOOTER //
// ./src/components/CodeOfHonor/modules/actions.js